module.exports = __webpack_public_path__ + "img/gn_06.42dfce72.png";